import { MultiSelect } from 'components/MultiSelect/MultiSelect'
import type { TOptions } from 'components/MultiSelect/MultiSelect.types'
import { translate } from 'i18n/i18n'
import _ from 'lodash'
import React, { useMemo } from 'react'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'

type InsectMultiSelectProps = {
  selectedIds: number[]
  onChange: (selectedIds: number[]) => void
}

export const InsectMultiSelect: React.FC<InsectMultiSelectProps> = ({ selectedIds, onChange }) => {
  const allInsects = fieldAssetStore.useSelector((s) => s.insects)

  const insectOptions = useMemo(() => {
    if (!allInsects) return []

    return _.sortBy(
      Object.values(allInsects)
        .filter((insect) => insect.enabled)
        .map((insect) => ({ label: insect.name, value: insect.insectId })),
      'label',
    )
  }, [allInsects])

  const selectedOptions = useMemo(
    () => selectedIds.map((value) => ({ value, label: allInsects?.[value].name })),
    [selectedIds, allInsects],
  )

  const handleSelectionChange = (selectedOptions: TOptions[]) => {
    const statuses = selectedOptions.map((option) => option.value) as number[]

    onChange(statuses)
  }

  return (
    <MultiSelect
      data={insectOptions}
      onChange={handleSelectionChange}
      placeholder={translate.phrases.placeholder('Filter by pest')}
      selectedData={selectedOptions}
    />
  )
}
